import { jsx as _jsx } from "react/jsx-runtime";
import { useBrand, useEnv } from "@/contexts/cdpConfig";
import { useConfirmationPage } from "@/contexts/confirmPage";
import { useIsIntersecting } from "@/hooks";
import { useTrackingSimilarListingLoad } from "@/hooks/tracking/useTrackingSimilarListingLoad";
import { useI18n } from "@/shared/hooks";
import { CardMFEProvider } from "@aviv-classified-card/card/full";
import { useLocale } from "@aviv-unified-frontend/runtime/i18n";
import { Carousel as GeminiCarousel } from "@gemini/ui";
import { useEffect } from "react";
import { SimilarCard } from "./SimilarCard";
import { SimilarContainer } from "./ui";
import { useSimilarCarousel } from "./useSimilarCarousel";
import { useSimilarListingsClassifiedAnalyticsTracking } from "@/components/SimilarListings/useSimilarListingsClassifiedAnalyticsTracking";
import { usePriceDropVariant } from "@/hooks/usePriceDropVariant";
export const similarListingCarouselTestId = "cdp-similar-listings-carousel";
export const similarProviderListingCarouselTestId = "cdp-similar-provider-listings-carousel";
export const SimilarListingsCarousel = ({ display, similarListings, similars, isSimilarProviderListings = false, isErrorPageDisplay = false, }) => {
    const priceDropsVariant = usePriceDropVariant();
    const sendSimilarListingTracking = useTrackingSimilarListingLoad(similarListings);
    const { isIntersecting } = useIsIntersecting({
        elementId: "similarListings",
        triggerOnce: true,
        rootMargin: "0px",
    });
    const testId = isSimilarProviderListings
        ? similarProviderListingCarouselTestId
        : similarListingCarouselTestId;
    const { sendSimilarListingsAnalytics } = useSimilarListingsClassifiedAnalyticsTracking();
    const { nbItemsDisplayed, cardWidth } = useSimilarCarousel();
    const brand = useBrand();
    const env = useEnv();
    const { language } = useLocale();
    const { t } = useI18n();
    const isCarouselDisplayed = (similarListings === null || similarListings === void 0 ? void 0 : similarListings.length) > nbItemsDisplayed;
    const { showConfirm } = useConfirmationPage();
    const getTrackingMediumValue = () => {
        const classifiedPageTrackingMedium = showConfirm
            ? "classified_detail_lead_confirmation_similars_bottom_classified_detail"
            : "classified_detail_similars_bottom_classified_detail";
        const errorPageTrackingMedium = isSimilarProviderListings
            ? "classified_detail_error_provider_classified_detail"
            : "classified_detail_error_similar_classified_detail";
        return isErrorPageDisplay
            ? errorPageTrackingMedium
            : classifiedPageTrackingMedium;
    };
    const trackingMediumValue = getTrackingMediumValue();
    useEffect(() => {
        if (display && isIntersecting)
            sendSimilarListingTracking();
    }, [display, isIntersecting, sendSimilarListingTracking]);
    useEffect(() => {
        if (isIntersecting) {
            sendSimilarListingsAnalytics(similarListings.slice(0, nbItemsDisplayed).map((item) => item.id));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isIntersecting]);
    if (!display)
        return null;
    const title = isSimilarProviderListings
        ? t("similar_provider_listings.title")
        : t("similar_listings.title_v2");
    return (_jsx(CardMFEProvider
    // @ts-ignore
    , { 
        // @ts-ignore
        cards: similars, brand: brand === "immoweltat" ? "immowelt" : brand, locale: language, stage: env, formatBreakpoints: { vertical: "base" }, fixedCardHeight: { active: true, keyFactsWidth: `${cardWidth - 32}` }, isCarouselMode: true, featureFlags: {
            price_drops: priceDropsVariant,
        }, children: _jsx(SimilarContainer, { testId: testId, marginRight: "spacing.20", children: _jsx(GeminiCarousel, { itemsPerView: nbItemsDisplayed, arrowPosition: "outside", title: title, itemsFixedWidth: cardWidth, items: similarListings.map((item) => ({
                    id: item.id,
                    item: (_jsx(SimilarCard, { item: item, width: `${cardWidth}px`, trackingMedium: trackingMediumValue }, item.id)),
                })), step: "grouped", hasDots: isCarouselDisplayed, dotsPosition: "outside", onChange: (value) => {
                    sendSimilarListingsAnalytics(value.visibleItemIds);
                } }) }) }));
};
